// src/config/prizes.js
//
// GENERATED by scripts/sync-prizes.js from api/_prizes.js: do not edit by hand.
// api/_prizes.js is the source of truth for the odds; CRA cannot import from
// outside src/, so the table is copied here and src/config/prizes.test.js fails
// if the two differ. Change api/_prizes.js, then run `node scripts/sync-prizes.js`.

import { PRIZE_WHEEL_UNTIL, PRIZE_VALID_UNTIL } from "./features";

export { PRIZE_WHEEL_UNTIL, PRIZE_VALID_UNTIL };

export const TOTAL_WEIGHT = 1000;

export const PRIZES = [
  {"id":"disc-5","tier":"common","weight":320,"label":"5% הנחה על חבילה לבחירתך"},
  {"id":"disc-10","tier":"common","weight":260,"label":"10% הנחה על חבילות צילום לבחירתך (בתחרות)"},
  {"id":"fast-delivery","tier":"medium","weight":150,"label":"שדרוג לאספקה מהירה"},
  {"id":"disc-15-two","tier":"medium","weight":130,"label":"15% הנחה על תמונות בשתי התחרויות הבאות לבחירתך"},
  {"id":"disc-20-video","tier":"low","weight":80,"label":"20% הנחה על סרטון ריל / סרטון ארוך"},
  {"id":"disc-50","capped":true,"tier":"rare","weight":25,"label":"50% הנחה על חבילה לבחירתך (בתחרות אחת)"},
  {"id":"pack-gift","capped":true,"tier":"rare","weight":12,"label":"חבילת תמונות מורחבת במתנה"},
  {"id":"reel-gift","capped":true,"tier":"rare","weight":8,"label":"סרטון ריל במתנה"},
  {"id":"three-free","capped":true,"tier":"ultra","weight":10,"label":"כרטיסייה: תמונות רגילות בחינם בשלוש התחרויות הבאות + סרטון קצר אחד"},
  {"id":"team","capped":true,"tier":"ultra","weight":4,"special":"team","label":"קבוצה מנצחת — הזוכה בוחר 5 חברים שמקבלים יחד איתו 50% הנחה על חבילות לבחירתם"},
  {"id":"jackpot","capped":true,"tier":"jackpot","weight":1,"special":"jackpot","label":"ג'קפוט — סרטון ארוך במתנה + חבילת תמונות מורחבת, לשתי תחרויות לבחירתך (לא שניהם באותה תחרות)"},
];

export const prizeById = (id) => PRIZES.find((p) => p.id === id) || null;
export const isCapped = (id) => !!prizeById(id)?.capped;

/** The calendar date in Israel, "YYYY-MM-DD". */
export function israelDay(now = new Date()) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Jerusalem",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
}

/** Is the wheel still open? Same rule as the server, on the visitor's clock. */
export const wheelOpen = (now = new Date()) => israelDay(now) <= PRIZE_WHEEL_UNTIL;

/** Has a prize that was valid until `validUntil` run out? */
export const isExpired = (validUntil, now = new Date()) => !validUntil || israelDay(now) > validUntil;

/** 2026-12-31 -> 31.12.2026 (numeric, so it reads the same in every language). */
export const dmy = (iso) => String(iso).split("-").reverse().join(".");
